import React, { forwardRef } from "react";
import "./invoice-pdf.scss";
import icons from "../../../../../../assets/icons/icons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

interface InvoiceItem {
  description: string;
  quantity: number;
  unitPrice: number;
  total: number;
}

interface InvoiceData {
  invoiceId: string;
  issueDate: string;
  quantity?: number;
  totalAmount: number;
}

interface Props {
  data: InvoiceData;
  orderData?: any;
  amount?: any;
  issuedDate?: any;
}

const Invoice = forwardRef<HTMLDivElement, Props>(
  ({ data, orderData, amount, issuedDate }, ref) => {
    const formattedData = { ...data, quantity: 1 };
    return (
      <div className="invoice-container">
        <div className="invoice-wrapper">
          <div ref={ref} className="invoice-content">
            <div className="invoice-header">
              <div>
                <img
                  src={icons.AFPLogo}
                  alt="Company Logo"
                  className="company-logo"
                />
              </div>
              <div className="company-info">
                <p className="subtitle">#{formattedData.invoiceId}</p>
              </div>
            </div>
            <div className="invoice-title">
              <h1>Invoice</h1>
            </div>
            <div className="invoice-date">
              <p>
                Date:{" "}
                <span>
                  {dayjs
                    .utc(issuedDate || formattedData.issueDate)
                    .local()
                    .format("D MMMM, YYYY")}
                </span>
              </p>
            </div>
            <div className="address-section">
              <div className="address">
                <h3>Billed to:</h3>
                <p>
                  {orderData?.companydetails?.companyName}
                  <br />
                  {orderData?.companyAddress?.street_line_1 ?? ""}
                  <br />
                  {orderData?.companyAddress?.state ||
                  orderData?.companyAddress?.country
                    ? `${orderData?.companyAddress?.state ?? ""}${orderData?.companyAddress?.state && orderData?.companyAddress?.country ? ", " : ""}${orderData?.companyAddress?.country ?? ""}`
                    : ""}
                  <br />
                  {orderData?.companydetails?.email ?? ""}
                </p>
              </div>
              <div className="address">
                <h3>From:</h3>
                <p>
                  AFP
                  <br />
                  Walhalla
                  <br />
                  South Carolina, United States
                  <br />
                </p>
              </div>
            </div>

            <table className="invoice-table">
              <thead>
                <tr>
                  <th>Plan Name</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{orderData?.selectedPlan ?? ""}</td>
                  <td>{formattedData.quantity ?? 1}</td>
                  <td>${Number(amount) ?? 0}</td>
                  <td>${Number(amount) * formattedData.quantity}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td>Total</td>
                  <td>${Number(amount) * formattedData.quantity}</td>
                </tr>
              </tbody>
            </table>

            <div className="footer-section">
              <p>
                Note: <span>Thank you for chosing us!</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default Invoice;
